import { Link, useLocation } from '@tanstack/react-router';

import { supportedLocaleCodes, supportedLocales } from '@content';
import { useLocale } from '@hooks/use-locale';
import { cn } from '@lib/theme';

export function LanguageSwitcher() {
  const location = useLocation();
  const { locale, localizePath, basePathname } = useLocale();

  return (
    <nav aria-label="Language selector" className="border-border/60 flex items-center rounded-full border p-1">
      {supportedLocaleCodes.map((targetLocale) => {
        const metadata = supportedLocales[targetLocale];
        const isActive = targetLocale === locale;

        return (
          <Link
            key={targetLocale}
            to={localizePath(basePathname, targetLocale)}
            search={location.search}
            lang={metadata.hrefLang}
            hrefLang={metadata.hrefLang}
            className={cn(
              'inline-flex min-h-10 items-center rounded-full px-3 py-1 text-xs font-semibold tracking-[0.18em] uppercase transition',
              isActive
                ? 'bg-accent text-accent-foreground'
                : 'text-muted-foreground hover:text-brand-peacock focus-visible:text-brand-peacock'
            )}
            aria-current={isActive ? 'page' : undefined}
            aria-label={
              isActive
                ? `${metadata.nativeLabel}, ${metadata.label}, selected`
                : `${metadata.nativeLabel}, switch language to ${metadata.label}`
            }
          >
            {metadata.nativeLabel}
          </Link>
        );
      })}
    </nav>
  );
}
